// extracted by mini-css-extract-plugin
export default {"isCorrect":"TextAnswer-modules__isCorrect__q7xwT"};